export default __webpack_public_path__ + "static/media/no-photo-ls-lg.9614f935.png";